import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadRetryHistoryComponent } from './lead-retry-history.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [
    LeadRetryHistoryComponent
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    CustomFlexLayoutModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule
  ],
  exports: [
    LeadRetryHistoryComponent
  ]
})
export class LeadRetryHistoryModule { }
